<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card  v-can="'view-work-orders'" titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8" :collapse-action="true">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">General</label>
              <vs-input type="search"  placeholder="Search.." v-model="filters['search']" class="mb-4 md:mb-0 w-full"/>
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
              <label class="text-sm opacity-100 text-bold">Status</label>
              <v-select  :clearable="true" placeholder=""  v-model="filters['status']"
                         :options="['Open','Confirmed', 'Paused', 'Cancelled', 'In Progress', 'Stopped', 'Dispatched to Supplier', 'Returned from Supplier' ,'Mix Completed', 'Pack Off In Progress', 'Pack Off Completed']"
                         :dir="$vs.rtl ? 'rtl' : 'ltr'" multiple></v-select>
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">WO Type</label>
              <v-select  :clearable="true" placeholder=""  v-model="filters['is-stock']"
                         :options="[{ label: 'For Sales Order(s)', value: false }, { label: 'For Stock', value: true }]"
                         :dir="$vs.rtl ? 'rtl' : 'ltr'" label="label" :reduce="option => option.value"></v-select>
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">QC Status</label>
              <v-select  :clearable="true" placeholder=""  v-model="filters['q_c_status']"
                         :options="[
                           { label: 'Not Submitted', value: 'Not Submitted to QC' },
                           { label: 'Sample Taken', value: 'Sample Taken By QC' },
                           { label: 'Submitted', value: 'Submitted to QC' },
                           { label: 'Approved', value: 'Approved by QC' },
                           { label: 'Rejected', value: 'Rejected by QC' }
                         ]"
                         label="label" :reduce="option => option.value"
                         :dir="$vs.rtl ? 'rtl' : 'ltr'" multiple></v-select>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Manufacturing Date</label>
              <div class="vx-row">
                <div class="vx-col w-1/2">
                  <flat-pickr style="display: none"
                          class="w-full"
                          :config="{ dateFormat: 'd/m/Y'}"
                          v-model="filters['date-from']"
                          placeholder="From"
                  />
                  <flat-pickr
                          class="w-full"
                          :config="{ dateFormat: 'd/m/Y'}"
                          v-model="filters['date-from']"
                          placeholder="From"
                  />
                </div>
                <div class="vx-col w-1/2">
                  <flat-pickr style="display: none"
                          class="w-full"
                          :config="{ dateFormat: 'd/m/Y'}"
                          v-model="filters['date-to']"
                          placeholder="To"
                  />
                  <flat-pickr
                          class="w-full"
                          :config="{ dateFormat: 'd/m/Y'}"
                          v-model="filters['date-to']"
                          placeholder="To"
                  />
                </div>
              </div>
            </div>
            <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Shipment Date</label>
              <div class="vx-row">
                <div class="vx-col w-1/2">
                  <flat-pickr style="display: none"
                          class="w-full"
                          :config="{ dateFormat: 'd/m/Y'}"
                          v-model="filters['shipment-date-from']"
                          placeholder="From"
                  />
                  <flat-pickr
                              class="w-full"
                              :config="{ dateFormat: 'd/m/Y'}"
                              v-model="filters['shipment-date-from']"
                              placeholder="From"
                  />
                </div>
                <div class="vx-col w-1/2">
                  <flat-pickr style="display: none"
                          class="w-full"
                          :config="{ dateFormat: 'd/m/Y'}"
                          v-model="filters['shipment-date-to']"
                          placeholder="To"
                  />
                  <flat-pickr
                              class="w-full"
                              :config="{ dateFormat: 'd/m/Y'}"
                              v-model="filters['shipment-date-to']"
                              placeholder="To"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row mt-5">
            <div class="vx-col w-full ml-auto">
              <vs-button class="float-right mr-4" size="small"
                         color="danger" type="border" icon-pack="feather" v-on:click="filters={}" >CLEAR</vs-button>
            </div>
          </div>
        </vx-card>

        <vx-card title="WORK ORDERS">
          <template  slot="actions">
            <div class="flex flex-wrap items-center gap-4 mb-4 relative z-50">
            <table-column-preference
              :columns="tableColumns"
              :default-columns="DEFAULT_WO_COLUMNS"
              :current-sort="sort"
              @sort="handlePreferenceSortChange"
              @change="handleColumnPreferenceChange"
              @reset="handleResetColumnPreferences(DEFAULT_WO_COLUMNS)"
            />
            <excel-download
              :name="'work-orders-sheet'"
              :filters="filters"
            />
            <vs-button v-can="'create-edit-work-orders'" @click="onClickCreateSite" class="" color="primary" type="filled">Create</vs-button>
            </div>
          </template>
          <div v-can="'view-work-orders'" slot="no-body" class="mt-4">
            <vs-table
              id="wo-list-table"
              ref="woTable"
              :max-items="(meta.per_page) ? meta.per_page : 10"
              :data="staff"
              @sort="handleSort"
              :sst="true"
              stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th v-if="isColumnVisible('work_order_date')" class="text-xs" width="5%" sort-key="work-order-date">MANUFACTURING DATE</vs-th>
                <vs-th v-if="isColumnVisible('work_order_code')" class="text-xs" width="10%" sort-key="work_order_code">WORK ORDER CODE</vs-th>
                <vs-th v-if="isColumnVisible('formulation_code')" class="text-xs" width="10%">ITS PRODUCT CODE/NAME</vs-th>
                <vs-th v-if="isColumnVisible('production_line_code')" class="text-xs" width="5%">PRODUCTION LINE CODE</vs-th>
                <vs-th v-if="isColumnVisible('type')" class="text-xs" width="5%">TYPE</vs-th>
                <vs-th v-if="isColumnVisible('order_items')" class="text-xs" width="10%">SO NUMBER / STOCK</vs-th>
                <vs-th v-if="isColumnVisible('required_by')" class="text-xs" width="5%" sort-key="required-by">REQUIRED BY DATE</vs-th>
                <vs-th v-if="isColumnVisible('shipment_date')" class="text-xs" width="5%" sort-key="shipment-date">SHIPMENT DATE</vs-th>
                <vs-th v-if="isColumnVisible('wo_quantity')" class="text-xs" width="5%" sort-key="created_at">WO QUANTITY (KG)</vs-th>
                <vs-th v-if="isColumnVisible('status')" class="text-xs" width="15%">WO STATUS</vs-th>
                <vs-th v-if="isColumnVisible('formulation_status')" class="text-xs" width="5%">FG PRODUCT STATUS</vs-th>
                <vs-th v-if="isColumnVisible('q_c_status')" class="text-xs" width="10%" sort-key="q_c_status">QC STATUS</vs-th>
                <vs-th v-if="isColumnVisible('action')" class="text-xs" width="10%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr @click.native="onClickViewWorkOrder(data[indextr].id)" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td v-if="isColumnVisible('work_order_date')" :data="data[indextr].work_order_date">
                    {{ data[indextr].work_order_date || 'N/A'}}
                  </vs-td>

                  <vs-td v-if="isColumnVisible('work_order_code')" class="font-semibold" :data="data[indextr].work_order_code">
                    {{data[indextr].work_order_code}}
                  </vs-td>

                  <vs-td v-if="isColumnVisible('formulation_code')" :data="data[indextr].formulation_code">
                    <span>
                      <vx-tooltip class="ml-2" text="View Product" position="left">
                        <a v-on:click.stop="onClickFinishedProduct(data[indextr].formulation_id)">{{ data[indextr].formulation_code }} <br> {{ data[indextr].formulation_name }}</a>
                      </vx-tooltip>
                    </span>
                  </vs-td>

                  <vs-td v-if="isColumnVisible('production_line_code')" :data="data[indextr].production_line_id.production_line_code">
                    {{data[indextr].production_line_id.production_line_code}}
                  </vs-td>

                  <vs-td v-if="isColumnVisible('type')" :data="data[indextr].production_line_id.type">
                    {{data[indextr].production_line_id.type}}
                  </vs-td>

                  <vs-td v-if="isColumnVisible('order_items')" :data="data[indextr].order_items">
                    <span v-if="data[indextr].order_items.length > 0" class="text-primary text-sm" v-for="(item, index) in data[indextr].order_items" :key="index">
                        {{item.order_code}},
                    </span>
                    <span class="text-primary font-semibold text-sm" v-if="data[indextr].order_items.length === 0">
                      STOCK
                    </span>
                  </vs-td>

                  <vs-td v-if="isColumnVisible('required_by')">
                    {{ data[indextr].required_by || 'N/A' }}
                  </vs-td>

                  <vs-td v-if="isColumnVisible('shipment_date')">
                    {{ data[indextr].shipment_date || 'N/A'}}
                  </vs-td>

                  <vs-td v-if="isColumnVisible('wo_quantity')">
                    <span v-if="data[indextr].order_items.length === 0">
                      {{ data[indextr].unallocated_amount }}
                    </span>
                    <span v-else>
                      {{ data[indextr].order_items.reduce((a, b) => a + Number(b.quantity), 0) + Number(data[indextr].unallocated_amount) }}
                    </span>
                  </vs-td>


<!--                  <vs-td :data="data[indextr].actual_start_time">-->
<!--                    {{ data[indextr].actual_start_time ? __utcToLocalTime(data[indextr].actual_start_time) : 'N/A'}} - -->
<!--                    {{ data[indextr].actual_end_time ? __utcToLocalTime(data[indextr].actual_end_time) : 'N/A'}}-->
<!--                  </vs-td>-->

                  <vs-td v-if="isColumnVisible('status')" :data="data[indextr].status.name">
                    <vs-chip class="text-xs text-center" style="border-radius: 0" transparent :color="data[indextr].status_color">
                      {{ data[indextr].status.name }}
                    </vs-chip>
                  </vs-td>
                  <vs-td v-if="isColumnVisible('formulation_status')" :data="data[indextr].formulation_status">
                    <vs-chip class="text-xs text-center" style="border-radius: 0" transparent :color="data[indextr].formulation_status === 'Production' ? 'success' : 'danger'">
                      {{ data[indextr].formulation_status }}
                    </vs-chip>
                  </vs-td>
                  <vs-td v-if="isColumnVisible('q_c_status')" :data="data[indextr].q_c_status">
                    <vs-chip transparent color="dark" class="text-xs text-center">
                      {{ qcStatusNameFactory(tr.q_c_status) }}
                    </vs-chip>
                  </vs-td>

                  <vs-td v-if="isColumnVisible('action')">
                    <div class="vx-row">
                      <vx-tooltip class="ml-2" text="View Work Order" position="left">
                        <vs-button @click.stop="onClickViewWorkOrder(data[indextr].id)"
                                   size="small" color="primary" type="filled" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip class="ml-2" text="Print work order" position="left">
                        <vs-button @click.stop="printWorkOrder(data[indextr].id)"
                                   size="small" color="warning" type="filled" icon-pack="feather" icon="icon-printer"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-if="!['Open', 'Cancelled'].includes(data[indextr].status.name)" class="ml-2" text="Open WO manufacture screen" position="left">
                        <vs-button @click.stop="onClickViewWorkOrderOnTimeline(data[indextr].id)"
                                   size="small" color="danger" type="filled" icon-pack="feather" icon="icon-maximize-2"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                </vs-tr>
              </template>

            </vs-table>

            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vs-pagination>


          </div>
        </vx-card>
      </div>
    </div>

    <vs-popup class="holamundo" title="" :active.sync="popupActive">
      <div class="vx-row mb-4 mt-8 mx-8">
        <div class="vx-col w-full">
          <vs-button @click="onClickCreateWo('customer')" class="w-full" color="primary" type="filled">CREATE WORK ORDER FOR CUSTOMER ORDERS</vs-button>
        </div>
      </div>
      <div class="vx-row mb-4 mx-8">
        <div class="vx-col w-full">
          <vs-button @click="onClickCreateWo('stock')" class="w-full" color="primary" type="border">CREATE WORK ORDER FOR STOCK</vs-button>
        </div>
      </div>
      <div class="vx-row mb-8 mx-8">
        <div class="vx-col w-full">
          <vs-button @click="onClickCreateWo('allocate')" class="w-full" color="warning" type="border">ALLOCATE FG STOCK FOR ORDERS</vs-button>
        </div>
      </div>
    </vs-popup>
    <view-work-order-pop-up v-on:refreshData="refreshData" ref="ViewWorkOrderPopUp"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  import TablePreference from '@/mixins/TablePreference';
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import {defaultPagination, perPageList} from "@/constants/config";
  import ViewWorkOrderPopUp from "@/components/popups/manufacturing/work-order/ViewWorkOrderPopUp";
  import TableColumnPreference from "@/components/table/TableColumnPreference.vue";
  const ManufacturingRepository = RepositoryFactory.get('manufacturing')
  import router from '@/router.js'
  import flatPickr from "vue-flatpickr-component";
  import 'flatpickr/dist/flatpickr.css'

  export default {
    name: 'WorkOrderList',
    data () {
      return {
        staff: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        perPage: defaultPagination,
        descriptionItems: perPageList,
        popupActive: false,
        DEFAULT_WO_COLUMNS: [
          { key: 'work_order_date', label: 'MANUFACTURING DATE', sortKey: 'work-order-date', defaultVisible: true },
          { key: 'work_order_code', label: 'WORK ORDER CODE', sortKey: 'work_order_code', defaultVisible: true },
          { key: 'formulation_code', label: 'ITS PRODUCT CODE/NAME', defaultVisible: true },
          { key: 'production_line_code', label: 'PRODUCTION LINE CODE', defaultVisible: true },
          { key: 'type', label: 'TYPE', defaultVisible: true },
          { key: 'order_items', label: 'SO NUMBER / STOCK', defaultVisible: true },
          { key: 'required_by', label: 'REQUIRED BY DATE', sortKey: 'required-by', defaultVisible: true },
          { key: 'shipment_date', label: 'SHIPMENT DATE', sortKey: 'shipment-date', defaultVisible: true },
          { key: 'wo_quantity', label: 'WO QUANTITY (KG)', sortKey: 'created_at', defaultVisible: true },
          { key: 'status', label: 'WO STATUS', defaultVisible: true },
          { key: 'formulation_status', label: 'FG PRODUCT STATUS', defaultVisible: true },
          { key: 'q_c_status', label: 'QC STATUS', sortKey: 'q_c_status', defaultVisible: true },
          { key: 'action', label: 'ACTION', defaultVisible: true, locked: true }
        ]
      }
    },
    components: {
      'v-select': vSelect,
      ViewWorkOrderPopUp,
      flatPickr,
      TableColumnPreference
    },
    mixins : [Filter, TablePreference, SuccessMessage, ErrorMessages],
    async mounted () {
      this.initTablePreferences('work_orders', this.DEFAULT_WO_COLUMNS, '-shipment-date', 'woTable')
      this.setFilterId('work_order_list_filters',['search','status','date-from','date-to','shipment-date-from','shipment-date-to','q_c_status'])
      if (this.$route.query.open ) {
        await this.$refs.UpdateCustomerProjectBriefPopUp.openPopup(this.$route.query.open)
      }
    },
    methods: {
      async refreshData () {
        this.fetchWorkOrderList()
      },

      async fetchWorkOrderList() {
        await this.$vs.loading({
          container: '#wo-list-table',
          scale: 0.45
        })
        try {
          const {data} = await ManufacturingRepository.getAllWorkOrders(this.page, this.filterQuery, this.perPage, `${this.sort || '-shipment-date'}`)
          this.staff = []
          this.staff =  data.data.map((x) => {
            x.status_color  = this.workOrdersColorFactory(x.status.id)
            return x
          })
          this.meta = data.meta
          this.$nextTick(() => {
            this.syncTableSortUI('woTable')
          })
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#wo-list-table > .con-vs-loading')
      },

      async onClickCreateSite () {
        this.popupActive = true
      },
      async onClickCreateWo(type) {
        await this.closePopUp()
        if(type === 'customer') {
          this.$router.push({path: `/pages/manufacturing/work-orders/create`})
        }
        if(type === 'stock') {
          this.$router.push({path: `/pages/manufacturing/work-orders/create-stock`})
        }
        if(type === 'allocate') {
          this.$router.push({path: `/pages/manufacturing/allocate-from-stock`})
        }
      },
      async closePopUp() {
        this.popupActive = false
      },
      filterQueryUpdate (){
        this.page = 1
        this.fetchWorkOrderList()
      },

      handleChangePage(page) {
        this.page=page;
        this.fetchWorkOrderList()
      },
      changePage(index) {
        this.perPage = this.descriptionItems[index]
      },
      onClickFinishedProduct(id) {
        router.push({path: `/pages/formulations/${id}`})
      },
      async onClickViewWorkOrder (id) {
        this.$router.push({path: `/pages/manufacturing/work-orders/${id}/details`})
      },
      async onClickViewWorkOrderOnTimeline(id) {
        // this.$router.push({path: `/pages/manufacturing/manufacturing-timeline?wo=${id}`})
        this.$refs.ViewWorkOrderPopUp.openPopup(id)
      },
      printWorkOrder(id){
        let routeData = this.$router.resolve({name: 'work-order-print-view', params: {id: id }});
        window.open(routeData.href, '_blank');
      },
      workOrdersColorFactory(id) {
        switch (id) {
          case 1:
            return '#a0937d';
          case 2:
            return 'primary';
          case 3:
            return '#FF8970';
          case 4:
            return 'warning';
          case 5:
            return '#00adb5';
          case 6:
            return 'danger';
          case 7:
            return '#638300';
          case 8:
            return '#638300';
          case 9:
            return '#09C154';
          default:
            return 'dark'
        }
      },
      qcStatusNameFactory(name) {
        if(!name) { return 'N/A' }
        switch (name) {
          case 'Not Submitted to QC':
            return 'Not Submitted'
          case 'Submitted to QC':
            return 'Submitted'
          case 'Sample Taken By QC':
            return 'Sample Taken'
          case 'Approved by QC':
            return 'Approved'
          default:
            return name
        }
      }
    },
    watch : {
      page(){
        this.fetchWorkOrderList()
      },
      perPage() {
        this.fetchWorkOrderList()
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
